import { Request } from '../../Servidor/Request';

export class BuildingTypeRequest {
    private sgeptipoedificacao: number;
    private nome: string;

	constructor(sgeptipoedificacao: number, nome: string) {
		this.sgeptipoedificacao = sgeptipoedificacao;
		this.nome = nome;
	}


    /**
     * Getter sgeptipoedificacao
     * @return {number}
     */
	public getSgeptipoedificacao(): number {
		return this.sgeptipoedificacao;
	}

    /**
     * Getter nome
     * @return {string}
     */
	public getNome(): string {
		return this.nome;
	}
}

export class BuildingTypeStructRequest {
    private sgeptipoedificacao: number;

	constructor(sgeptipoedificacao: number) {
        this.sgeptipoedificacao = sgeptipoedificacao;
	}


    /**
     * Getter sgeptipoedificacao
     * @return {number}
     */
	public getSgeptipoedificacao(): number {
		return this.sgeptipoedificacao;
	}

}

export class BuildingTypeStructResponse {
    private sgeptipoedificacao: number;
    private nome: string;

	constructor(sgeptipoedificacao: number, nome: string) {
		this.sgeptipoedificacao = sgeptipoedificacao;
		this.nome = nome;
	}


    /**
     * Getter sgeptipoedificacao
     * @return {number}
     */
	public getSgeptipoedificacao(): number {
		return this.sgeptipoedificacao;
	}

    /**
     * Getter nome
     * @return {string}
     */
	public getNome(): string {
		return this.nome;
	}
}

export class BuildingTypeInteractor {
    public fetchSave(request: BuildingTypeRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("propriedade/tipo-edificacao/salvar", request).then((rs) => {
                if(rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                let response = rs.Status == "Sucesso"
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: BuildingTypeStructRequest): PromiseLike<BuildingTypeStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("propriedade/tipo-edificacao/buscar", request).then((rs) => {
                if(rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}